import { IPreviewData, IProductFormData, ICharacteristic } from 'models/product'
import { normalizeNumber } from 'shared/utils/normalizeNumber'

const isFilledCharacteristic = (
  item: { name?: string; value?: string }
): item is ICharacteristic => {
  const name = typeof item?.name === 'string' ? item.name.trim() : ''
  const value = typeof item?.value === 'string' ? item.value.trim() : ''

  return !!name && !!value
}

export const getPreviewData = (
  data: IProductFormData,
  category: string,
  subCategory: string
): IPreviewData => {
  const normalizeCharacteristics = (
    characteristics?: { name?: string; value?: string }[]
  ): ICharacteristic[] => (characteristics || []).filter(isFilledCharacteristic)

  const allCharacteristics = [
    ...normalizeCharacteristics(data?.characteristics),
    ...normalizeCharacteristics(data?.optionalCharacteristics),
    ...normalizeCharacteristics(data?.requiredCharacteristics)
  ]

  return {
    photo: data.photo,
    categoryName: category,
    subCategoryName: subCategory,
    name: data.name,
    price: normalizeNumber(data.price),
    desc: data.desc,
    dimension: {
      width: normalizeNumber(data.width),
      length: normalizeNumber(data.length),
      height: normalizeNumber(data.height),
      weight: normalizeNumber(data.weight),
      unit: data.unit,
      in_stock: normalizeNumber(data.in_stock)
    },
    characteristics: allCharacteristics,
    variations: data?.variations ?? []
  }
}
